import React, { useContext, useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { FaLock } from "react-icons/fa";
import { Context } from "../../context/UserContext";



export default function ChangePasswordModal({
  isModalOpen,
  setModalOpen,
}) {

    const { changePassword } = useContext(Context)

    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
        reset,
    } = useForm();

    const watchPassword = watch('newPassword')


  useEffect(() => {
    
  }, []);

  const onSubmit = async (data) => {
    // console.log(data)
    try {
      // Chamada para a função de alteração de senha
      await changePassword(data);
    } catch (error) {
      console.error("Erro ao alterar a senha", error);
    }
  };

  const onClose = () => {
    reset();
    setModalOpen(!isModalOpen);
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col max-w-[700px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">
                <div className="flex gap-2 items-center text-white text-xl font-bold">
                  <FaLock />
                  TROCAR SENHA
                </div>
                {/* <div className="ms-4 flex justify-between">
                  <div className="text-sm">
                    Solicitação nº: {requestObject?.request?.idRequest}
                  </div>
                  <div className="text-sm">
                    Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
                  </div>
                  <div className="flex items-center gap-2">
                    Status:
                    <p  className="text-sm text-black rounded-lg px-2"
                        style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div> */}
              </div>

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-12">
                <div className="w-full relative inline-block text-left">

                  <form onSubmit={handleSubmit(onSubmit)} className="w-full flex flex-col text-sm gap-2">
                    {/* <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <div className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Iniciar o atendimento desta solicitação?
                      </div>
                      <div className="w-1/5 block text-red-700 italic whitespace-nowrap">
                        Esta ação não pode ser desfeita
                      </div>
                    </div> */}
                    
                    <div className="flex items-center justify-between gap-2">
                        <label className="w-full block text-sm font-medium text-gray-900 whitespace-nowrap">
                            Senha Atual:
                        </label>
                        <div className="w-full">
                            <input
                            {...register("password", { required: true, minLength: 3 })}
                            type="password"
                            autoComplete="current-password"
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                errors?.password?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                                `}
                            />
                            {errors?.password?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                                Senha é obrigatório
                            </p>
                            )}
                            {errors?.password?.type === "minLength" && (
                            <p className="text-red-500 text-xs ms-2">
                                Senha de ter um mín de 3 caracteres
                            </p>
                            )}
                        </div>
                    </div>

                    <div className="flex items-center justify-between gap-2">
                        <label className="w-full block text-sm font-medium text-gray-900 whitespace-nowrap">
                            Nova Senha:
                        </label>
                        <div className="w-full">
                            <input
                            {...register("newPassword", { required: true, minLength: 3 })}
                            type="password"
                            autoComplete="new-password"
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                errors?.newPassword?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                                `}
                            />
                            {errors?.newPassword?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                                Senha é obrigatório
                            </p>
                            )}
                            {errors?.newPassword?.type === "minLength" && (
                            <p className="text-red-500 text-xs ms-2">
                                Senha de ter um mín de 3 caracteres
                            </p>
                            )}
                        </div>
                    </div>

                    <div className="flex items-center justify-between gap-2">
                        <label className="w-full block text-sm font-medium text-gray-900 whitespace-nowrap">
                            Confirmar Nova Senha
                        </label>
                        <div className="w-full">
                            <input
                            {...register("confirmNewPassword", { required: true, validate: (value) =>  value === watchPassword  })}
                            type="password"
                            autoComplete="new-password"
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                                ${
                                errors?.confirmNewPassword?.type === "required" ?
                                " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                                }
                                `}
                            />
                            {errors?.confirmNewPassword?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                                Confirmar Senha é obrigatório
                            </p>
                            )}
                            {errors?.confirmNewPassword?.type === "validate" && (
                            <p className="text-red-500 text-xs ms-2">
                                As senhas não conferem
                            </p>
                            )}
                        </div>
                    </div>

                    <div className="flex gap-4 mt-6">
                      <button
                        // onClick={() => handleSubmit(onSubmit)()}
                        type="submit"
                        className="w-full bg-blue-500 text-white py-2 px-4 rounded-2xl hover:bg-blue-600"
                      >
                        Salvar
                      </button>

                      <button
                        onClick={() => setModalOpen(!isModalOpen)}
                        className="w-full bg-gray-500 text-white py-2 px-4 rounded-2xl hover:bg-gray-600"
                      >
                        Cancelar
                      </button>
                    </div>

                  </form>

                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    );
  }
}
